import * as types from './types';
import * as locationActions from 'services/api/locations';
import { getErrorMessage, parsePagination, isCancel } from 'utils';
import { uiActions } from 'state/modules/UI';
import i18n from 'i18n-js';

// Get locations
const fetchLocationsRequest = () => ({
  type: types.FETCH_LOCATIONS_REQUEST,
});

const fetchLocationsSuccess = (payload) => ({
  type: types.FETCH_LOCATIONS_SUCCESS,
  payload,
});

const fetchLocationsFailed = () => ({
  type: types.FETCH_LOCATIONS_FAILED,
});

export const fetchLocations = (params = {}, options) => {
  return async (dispatch) => {
    dispatch(fetchLocationsRequest());

    const response = await locationActions.fetchLocations(params, options);

    if (response.ok) {
      const pagination = parsePagination(response.headers);
      return dispatch(
        fetchLocationsSuccess({
          pagination: pagination,
          data: response.data,
        })
      );
    }

    if (!isCancel(response)) {
      const error = getErrorMessage(response.data);

      dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: error,
        })
      );

      dispatch(fetchLocationsFailed(error));
    }
  };
};
// Get location by ID
const fetchLocationsByIdRequest = () => ({
  type: types.FETCH_LOCATIONS_BY_ID_REQUEST,
});

const fetchLocationsByIdSuccess = (payload) => ({
  type: types.FETCH_LOCATIONS_BY_ID_SUCCESS,
  payload,
});

const fetchLocationsByIdFailed = () => ({
  type: types.FETCH_LOCATIONS_BY_ID_FAILED,
});

export const fetchLocationsById = (id) => {
  return async (dispatch) => {
    dispatch(fetchLocationsByIdRequest());

    const response = await locationActions.fetchLocationsById(id);

    if (response.ok) {
      return dispatch(fetchLocationsByIdSuccess(response.data));
    }

    const error = getErrorMessage(response.data);

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: error,
      })
    );

    dispatch(fetchLocationsByIdFailed(error));
  };
};
// Create location
const createLocationRequest = () => ({
  type: types.CREATE_LOCATION_REQUEST,
});

const createLocationSuccess = (payload) => ({
  type: types.CREATE_LOCATION_SUCCESS,
  payload,
});

const createLocationFailed = (errors) => ({
  type: types.CREATE_LOCATION_FAILED,
  errors,
});

export const createLocation = (data) => {
  return async (dispatch) => {
    dispatch(createLocationRequest());

    const response = await locationActions.createLocation(data);

    if (response.ok) {
      return dispatch(createLocationSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, { fullObject: true });

    if (typeof formattedError === 'string') {
      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(createLocationFailed(errors));
  };
};
// Update location
const updateLocationRequest = () => ({
  type: types.UPDATE_LOCATION_REQUEST,
});

const updateLocationSuccess = (payload) => ({
  type: types.UPDATE_LOCATION_SUCCESS,
  payload,
});

const updateLocationFailed = (errors) => ({
  type: types.UPDATE_LOCATION_FAILED,
  errors,
});

export const updateLocation = (id, data) => {
  return async (dispatch) => {
    dispatch(updateLocationRequest());

    const response = await locationActions.updateLocation(id, data);

    if (response.ok) {
      return dispatch(updateLocationSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, { fullObject: true });

    if (typeof formattedError === 'string') {
      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message: formattedError,
        })
      );
    }

    let errors = {};

    formattedError?.length &&
      formattedError.map((val) => {
        return (errors[val.field] = val.message);
      });

    dispatch(updateLocationFailed(errors));
  };
};
const deleteLocationRequest = () => ({
  type: types.DELETE_LOCATION_REQUEST,
});

const deleteLocationSuccess = (payload) => ({
  type: types.DELETE_LOCATION_SUCCESS,
  payload,
});

const deleteLocationFailed = (errors) => ({
  type: types.DELETE_LOCATION_FAILED,
  errors,
});

export const deleteLocation = (id) => {
  return async (dispatch) => {
    dispatch(deleteLocationRequest());

    const response = await locationActions.deleteLocation(id);

    if (response.ok) {
      dispatch(
        uiActions.handleShowSnackbar({
          type: 'success',
          message: i18n.t('locations.deleted'),
        })
      );
      dispatch(fetchLocations());
      return dispatch(deleteLocationSuccess(response.data));
    }

    const formattedError = getErrorMessage(response.data, { fullObject: true });

    if (typeof formattedError === 'string') {
      dispatch(deleteLocationFailed(formattedError));

      return dispatch(
        uiActions.handleShowSnackbar({
          type: 'error',
          message:
            typeof formattedError === 'string'
              ? formattedError
              : formattedError[0]
              ? formattedError[0].message
              : '',
        })
      );
    }

    dispatch(
      uiActions.handleShowSnackbar({
        type: 'error',
        message: formattedError[0]?.message,
      })
    );

    dispatch(deleteLocationFailed(formattedError));
  };
};
// Reset location state
const reseteLocationStateRequest = () => ({
  type: types.RESET_LOCATION_STATE_REQUEST,
});

export const resetLocationState = () => {
  return async (dispatch) => {
    return dispatch(reseteLocationStateRequest());
  };
};
